import { StorageGet } from '../storage/index';
import { UseCase } from '../UseCase';

export class GetOAuthError implements UseCase<void, string | undefined> {
    private storageGet = new StorageGet<string>();

    execute(): string | undefined {
        return this.storageGet.execute('oauth.error');
    }
}
